import LiveCasino from './live-casino';

export default LiveCasino;
